import {
    EzString
} from '/ezlibrary/helpers/EzHelpers.js';
import { EzEnumeration2 } from '/ezlibrary/enums/EzEnumeration2.js';

/**
    TODO: Extends from EzEnumeration2.js
    Defines the possible time entry dialog modes.
    Import with:
        import { EzTimeAddEditDialogMode } from '/secure/widgets/EzTimeAddEditDialog/EzTimeAddEditDialogMode.js';
 */
export class EzTimeAddEditDialogMode extends EzEnumeration2 {
    /**
     * @pulic @static @readonly @property
     * Returns an array of dialog mode submit messages.
     * @returns {array}
     */
    static get ezTimeAddEditDialogModeSubmitMsg() {
        return [
            EzTimeAddEditDialogMode.UNKNOWN,
            EzTimeAddEditDialogMode.ADD_TIME_ENTRY,
            EzTimeAddEditDialogMode.UPDATE_TIME_ENTRY,
            EzTimeAddEditDialogMode.UPDATE_ACTIVE_TIME_ENTRY,
            EzTimeAddEditDialogMode.ADD_BREAK,
            EzTimeAddEditDialogMode.UPDATE_BREAK,
            EzTimeAddEditDialogMode.UPDATE_ACTIVE_BREAK
        ];
    }

    /**
     * @public @static @method
     * Returns the matching enumeration value for the provided value. If the provided value
     * does not match any known enumeration values, UNKNOWN is returned.
     * @param {string} ezTimeAddEditDialogMode
     * @returns {string}
     * A defined value in EzTimeAddEditDialogMode
     * @deprecated
     * Migrate to: EzTimeAddEditDialogMode.ezValueOf(...)
     */
    static ezFromValue(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.ezValueOf(ezTimeAddEditDialogMode);
    }

    /**
     * @public @static @method
     * Returns if the provided EzTimeAddEditDialogMode value is for adding a new time entry or break.
     * @param {string} ezTimeAddEditDialogMode
     * A valid enum property value of EzTimeAddEditDialogMode
     * @returns {boolean}
     */
    static ezIsAddDialogMode(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.ezIsAddTimeEntryDialogMode(ezTimeAddEditDialogMode) ||
            EzTimeAddEditDialogMode.ezIsAddBreakDialogMode(ezTimeAddEditDialogMode);
    }

    /**
     * @public @static @method
     * Returns if the provided EzTimeAddEditDialogMode value is for adding a new time entry.
     * @param {string} ezTimeAddEditDialogMode
     * A valid enum property value of EzTimeAddEditDialogMode
     * @returns {boolean}
     */
    static ezIsAddTimeEntryDialogMode(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.ADD_TIME_ENTRY === ezTimeAddEditDialogMode;
    }

    /**
     * @public @static @method
     * Returns if the provided EzTimeAddEditDialogMode value is for adding a new break.
     * @param {string} ezTimeAddEditDialogMode
     * A valid enum property value of EzTimeAddEditDialogMode
     * @returns {boolean}
     */
    static ezIsAddBreakDialogMode(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.ADD_BREAK === ezTimeAddEditDialogMode;
    }

    /**
     * @public @static @method
     * Returns if the provided EzTimeAddEditDialogMode value is for updating
     * a time entry or break (active and non-active).
     * @param {string} ezTimeAddEditDialogMode
     * A valid enum property value of EzTimeAddEditDialogMode
     * @returns {boolean}
     */
    static ezIsUpdateDialogMode(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.ezIsUpdateDialogMode(ezTimeAddEditDialogMode) ||
            EzTimeAddEditDialogMode.ezIsUpdateBreakDialogMode(ezTimeAddEditDialogMode);
    }

    /**
     * @public @static @method
     * Returns if the provided EzTimeAddEditDialogMode value is for updating a active or non-active time entry.
     * @param {string} ezTimeAddEditDialogMode
     * A valid enum property value of EzTimeAddEditDialogMode
     * @returns {boolean}
     */
    static ezIsUpdateTimeEntryDialogMode(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.UPDATE_TIME_ENTRY === ezTimeAddEditDialogMode ||
            EzTimeAddEditDialogMode.UPDATE_ACTIVE_TIME_ENTRY === ezTimeAddEditDialogMode;
    }

    /**
     * @public @static @method
     * Returns if the provided EzTimeAddEditDialogMode value is for updating a active time entry.
     * @param {string} ezTimeAddEditDialogMode
     * A valid enum property value of EzTimeAddEditDialogMode
     * @returns {boolean}
     */
    static ezIsUpdateActiveTimeEntryDialogMode(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.UPDATE_ACTIVE_BREAK === ezTimeAddEditDialogMode;
    }


    /**
     * @public @static @method
     * Returns if the provided EzTimeAddEditDialogMode value is for updating a active or non-active break
     * @param {string} ezTimeAddEditDialogMode
     * A valid enum property value of EzTimeAddEditDialogMode
     * @returns {boolean}
     */
    static ezIsUpdateBreakDialogMode(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.UPDATE_BREAK === ezTimeAddEditDialogMode ||
            EzTimeAddEditDialogMode.UPDATE_ACTIVE_BREAK === ezTimeAddEditDialogMode;
    }

    /**
     * @public @static @method
     * Returns if the provided EzTimeAddEditDialogMode value is for updating a active break
     * @param {string} ezTimeAddEditDialogMode
     * A valid enum property value of EzTimeAddEditDialogMode
     * @returns {boolean}
     */
    static ezIsUpdateActiveBreakDialogMode(ezTimeAddEditDialogMode) {
        return EzTimeAddEditDialogMode.UPDATE_ACTIVE_BREAK === ezTimeAddEditDialogMode;
    }

    /**
     * @static
     * @public @method
     * Example static method that returns the enumeration property's data.display value.
     * If the enumPropertyValue is not a valid enumeration property value, then EzEnumTemplate.UNKNOWN.display is returned.
     * @param {undefined|null|string} enumPropertyValue
     * A valid enumeration property value from EzEnumTemplate
     * @returns {string}
     */
    static ezToDisplayName(enumPropertyValue) {
        return EzString.stringWithTextDefault(
            EzString.hasText(enumPropertyValue)
                ? EzEnumTemplate.ezEnumData(enumPropertyValue)?.display
                : EzEnumTemplate.ezEnumData(EzEnumTemplate.UNKNOWN)?.display,
                enumPropertyValue);
    }

    /*
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * Initialization Section: ONLY PLACE INITIALIZATION CODE BEYOND THIS SECTION
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     */

    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     * @type {EzEnumTemplate}
     * Internal static instance of the EzEnumTemplate
     */
    static #ezTimeAddEditDialogModeSingleton = null;

    /**
     * @static
     * @private @method
     * Builds the enumeration properties and values for EzClockerAccountType
     */
    static #ezBuildEnumeration() {
        this.#ezTimeAddEditDialogModeSingleton.ezBuildEnumProp(
            // Enumeration Property Name
            'UNKNOWN',
            // Enumeration Property Value
            'UNKNOWN',
            // Optional Enumeration Data Value
            {
                value: 'UNKNOWN',
                display: 'UNKNOWN'
            });

        this.#ezTimeAddEditDialogModeSingleton.ezBuildEnumProp(
            'ADD_TIME_ENTRY',
            'ADD_TIME_ENTRY',
            {
                value: 'ADD_TIME_ENTRY',
                display: 'Add Time Entry'
            });

        this.#ezTimeAddEditDialogModeSingleton.ezBuildEnumProp(
            'UPDATE_TIME_ENTRY',
            'UPDATE_TIME_ENTRY',
            {
                value: 'UPDATE_TIME_ENTRY',
                display: 'Update Time Entry'
            });

        this.#ezTimeAddEditDialogModeSingleton.ezBuildEnumProp(
            'UPDATE_ACTIVE_TIME_ENTRY',
            'UPDATE_ACTIVE_TIME_ENTRY',
            {
                value: 'UPDATE_ACTIVE_TIME_ENTRY',
                display: 'Update Active Time Entry'
            });

        this.#ezTimeAddEditDialogModeSingleton.ezBuildEnumProp(
            'ADD_BREAK',
            'ADD_BREAK',
            {
                value: 'ADD_BREAK',
                display: 'Add Break'
            });

        this.#ezTimeAddEditDialogModeSingleton.ezBuildEnumProp(
            'UPDATE_BREAK',
            'UPDATE_BREAK',
            {
                value: 'UPDATE_BREAK',
                display: 'Update Break'
            });

        this.#ezTimeAddEditDialogModeSingleton.ezBuildEnumProp(
            'UPDATE_ACTIVE_BREAK',
            'UPDATE_ACTIVE_BREAK',
            {
                value: 'UPDATE_ACTIVE_BREAK',
                display: 'Update Active Break'
            });
    }

    /**
     * Static Initialization of EzExportAction
     */
    static {
        if (null == this.#ezTimeAddEditDialogModeSingleton) {
            this.#ezTimeAddEditDialogModeSingleton = new EzTimeAddEditDialogMode();

            this.#ezBuildEnumeration();

            globalThis.EzTimeAddEditDialogMode = this;
        }
    }

    /*
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * End of Initialziation Section: !! DO NOT PLACE ANY CODE BEYOND THIS SECTION !!
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     */
}
